import { render, staticRenderFns } from "./POPaymentSection.vue?vue&type=template&id=4cc31a48&scoped=true"
import script from "./POPaymentSection.vue?vue&type=script&lang=ts"
export * from "./POPaymentSection.vue?vue&type=script&lang=ts"
import style0 from "./POPaymentSection.vue?vue&type=style&index=0&id=4cc31a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc31a48",
  null
  
)

export default component.exports